import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { ApplicationConfigurationService } from "@app/core/services/ApplicationConfiguration.service";
import { InmateOffenseRecord } from "../models/inmate-offense-record.model";

/**
 * Reads the neutral InmateOffenseRecord contract published by story 1237 for
 * the case-context page. Stays a thin HTTP wrapper so panel components can
 * remain presentational and reusable.
 */
@Injectable({ providedIn: "root" })
export class CaseContextRecordsService {
  private static readonly BasePath = "/api/incarcerated-person-offense-records";

  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(ApplicationConfigurationService);

  private static readonly options = {
    headers: new HttpHeaders({
      "skip-error-interceptor": "yes",
      "skip-loading-interceptor": "yes",
    }),
    withCredentials: true,
  };

  getByIncarceratedPerson(incarceratedPersonId: number): Observable<InmateOffenseRecord[]> {
    return this.http.get<InmateOffenseRecord[]>(
      this.appConfig.apiUrl(`${CaseContextRecordsService.BasePath}/incarcerated-person/${incarceratedPersonId}`),
      CaseContextRecordsService.options,
    );
  }

  getByScheduledProceeding(scheduledProceedingId: number): Observable<InmateOffenseRecord[]> {
    return this.http.get<InmateOffenseRecord[]>(
      this.appConfig.apiUrl(`${CaseContextRecordsService.BasePath}/scheduled-proceeding/${scheduledProceedingId}`),
      CaseContextRecordsService.options,
    );
  }
}
